import { Stack } from '@mui/material'
import { Suspense, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { AppRoutesRouter } from 'src/app-routes'
import { CenteredSpinner } from 'src/components/Spinner'
import { CustomerStorageCtx, StorageContextProvider } from 'src/context/StorageContext'
import { DialogContextType, SystemPortal } from 'src/enums'
import { useDialogCtx, useUserCtx } from 'src/hooks/context-hooks'
import { DocumentStoragePage } from 'src/pages/locality/DocumentPage'
import Dashboard from 'src/pages/storage/Dashboard'
import DeviationContainer from 'src/screens/localities/deviations/DeviationContainer'

export const StorageRoutes = () => {
  const { dialogsCustom } = useDialogCtx()
  const { setActivePortal } = useUserCtx()

  useEffect(() => {
    setActivePortal(SystemPortal.Storage)
  }, [])

  return (
    <StorageContextProvider>
      {Object.values(dialogsCustom[DialogContextType.storageContext] ?? {})}
      <Stack minWidth={'100%'} minHeight={'calc(100vh - 200px)'} className="pb-4-core">
        <Suspense fallback={<CenteredSpinner />}>
          <Routes>
            <Route path={AppRoutesRouter.storage.dashboard} element={<Dashboard />} />
            <Route
              path={AppRoutesRouter.storage.deviation}
              element={<DeviationContainer context={CustomerStorageCtx} />}
            />
            <Route path={AppRoutesRouter.storage.documents} element={<DocumentStoragePage />} />
            <Route path="*" element={<div></div>} />
          </Routes>
        </Suspense>
      </Stack>
    </StorageContextProvider>
  )
}
